import React, { useContext } from 'react';
import { bcContext } from '../context';
import { MapPage } from '../MapPage';
import { MapModes } from '../MapPage/MapPage.types';

export const BCCurrentRegion = () => {
  const { task } = useContext(bcContext);

  if (!task) return null;

  return <MapPage current_dep={task.department_id} mode={MapModes.currentRegion} />;
};
